import { useTableDataQuery } from '@/modules/common';

import { SystemPromptCategoryResponse } from '../types';

export function useSystemPromptCategories() {
  return useTableDataQuery<SystemPromptCategoryResponse>({
    url: '/system-prompts/categories',
    persistState: true,
  });
}
